import { Component, Input, OnInit } from '@angular/core';
import { LeaderBoardService } from './leaderBoardService.service';
import { Player } from './player.model';

@Component({
  selector: 'app-leader-board',
  templateUrl: './leader-board.component.html',
  styleUrls: ['./leader-board.component.scss']
})
export class LeaderBoardComponent implements OnInit {

  @Input() game;
  downTimer;
  resetBoard = false;
  champion: Player;
  pass: string;
  constructor(private leaderBoardService: LeaderBoardService) { }

  ngOnInit(): void {
    this.champion = this.leaderBoardService.getFirstPlace();
  }

  onMouseDown() {
    clearTimeout(this.downTimer);
    this.downTimer = setTimeout(() => {
      this.resetBoard = true;
    }, 3000);
  }

  onMouseUp() {
    clearTimeout(this.downTimer);
    this.resetBoard = false;
  }

  onResetBoard() {
    if (this.pass == "1234") {
      this.leaderBoardService.resetBoard();
      this.champion = this.leaderBoardService.getFirstPlace();
    }
    this.resetBoard = false;
    this.pass = '';
  }
}
